import React from "react";
import injectSheet from "react-jss";
import { DragSource } from "react-dnd";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEmpty } from "lodash";

const FloorplanMedias = ({ classes, medias, height, used, onDelete, onSelect }) => isEmpty(medias) ? null : (
  <div className={classes.container}>
    {medias
      .map(item => (
        <FloorplanMedia
          key={item.id}
          item={item}
          classes={classes}
          disabled={used.includes(item.id)}
          onDelete={onDelete}
          onSelect={() => onSelect(item)}
        />
      ))}
  </div>
);

const imageSource = {
  beginDrag(props) {
    return {
      id: props.item.id,
      type: "media",
    };
  },
};

const FloorplanMedia = DragSource(
  "floorplan-media",
  imageSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
  }),
)(({ classes, item, connectDragSource, disabled, onDelete, onSelect }) => {
  const image = item.options.elements?.find(i => i.type === "image");
  return connectDragSource(
    <div className={clsx(classes.image, { [classes.disabled]: disabled })} onClick={onSelect}>
      <div className={classes.header}>
        <div className={classes.name}>{item.options.title}</div>
        <div
          className={classes.delete}
          onClick={e => {
            e.preventDefault();
            onDelete?.(item.id);
          }}
        >
          <FontAwesomeIcon
            icon={["fal", "trash-alt"]}
            className={classes.deleteIcon}
          />
        </div>
      </div>
      {!!image?.image?.preview_url && (
        <img src={image?.image?.preview_url} alt="" style={{ pointerEvents: "none" }} />
      )}
    </div>,
  );
});

const styles = theme => ({
  container: {
    display: "flex",
    "flex-wrap": "wrap",
    flex: 1,
    padding: [5, 15, 30],
    "overflow-x": "hidden",
    "overflow-y": "auto",
    "align-items": "flex-start",
  },
  image: {
    flex: 1,
    "max-width": "200px",
    "min-width": "200px",
    "transition-duration": theme.transitionDuration,
    "transition-property": "transform, opacity",
    cursor: "move",
    border: `1px solid ${theme.colorGrey}`,
    "border-radius": theme.borderRadius,
    margin: theme.spacing2,
    "background-color": theme.colorBackground,
    padding: theme.spacing2,
    "box-sizing": "border-box",
    "line-height": 0,

    "& img": {
      "border-radius": theme.borderRadius,
      width: "100%",
      height: 90,
      "object-fit": "cover",
      "object-position": "top",
    },

    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  name: {
    "text-align": "left",
    color: theme.textColor,
    "padding-bottom": theme.spacing2,
    "line-height": "1rem",
    flex: 1,
  },
  disabled: {
    opacity: 0.5,

    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  header: {
    display: "flex",
  },
  delete: {
    cursor: "pointer",
  },
  deleteIcon: {
    color: theme.colorSecondary,
  },
});

export default injectSheet(styles)(FloorplanMedias);
